<template>
  <j-form-container :disabled="disabled">
    <a-form :form="form" slot="detail">
      <a-row>
        <a-col :span="12">
          <a-form-item :label="$t('label.unitPriceType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-dict-select-tag
              :triggerChange="true"
              dictCode="unit_price_type"
              v-decorator="['unitPriceType',{'initialValue': '10', rules: validatorRules.unitPriceType.rules}]"
              @change="handleUnitPriceChange($event)"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-if="unitPrice10">
        <a-col :span="12">
          <!--label="公禽A级"-->
          <a-form-item :label="$t('label.maleBirdAGrade')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['roosterLevelOne', validatorRules.roosterLevelOne]" :placeholder="$t('label.pleaseEnterTheUnitPriceForTheRecoveryOfMaleBirdAGrade')" style="width: 84%"/> {{ $t('label.yuanKg') }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!--label="母禽A级"-->
          <a-form-item :label="$t('label.femaleAGrade')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['henLevelOne', validatorRules.henLevelOne]" :placeholder="$t('label.pleaseEnterTheUnitPriceForTheRecoveryOfFemaleBirdAGrade')" style="width: 84%"/> {{ $t('label.yuanKg') }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!--label="公禽B级"-->
          <a-form-item :label="$t('label.maleB')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['roosterLevelTwo', validatorRules.roosterLevelTwo]" :placeholder="$t('label.pleaseEnterTheUnitPriceOfMaleBirdBGrade')" style="width: 84%"/> {{ $t('label.yuanKg') }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!--label="母禽B级"-->
          <a-form-item :label="$t('label.femaleBirdBGrade')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['henLevelTwo', validatorRules.henLevelTwo]" :placeholder="$t('label.pleaseEnterTheUnitPriceOfBGradeOfFemaleBirds')" style="width: 84%"/> {{ $t('label.yuanKg') }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!--label="公禽残次"-->
          <a-form-item  :label="$t('label.maleBirdResidual')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['roosterLevelThree', validatorRules.roosterLevelThree]" :placeholder="$t('label.pleaseEnterTheUnitPriceOfMaleBirdResidualRecovery')" style="width: 84%"/> {{ $t('label.yuanKg') }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!--label="母禽残次"-->
          <a-form-item :label="$t('label.femaleBirdResidual')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input-number v-decorator="['henLevelThree', validatorRules.henLevelThree]" :placeholder="$t('label.pleaseEnterTheUnitPriceOfFemalePoultryResidualRecovery')" style="width: 84%"/> {{ $t('label.yuanKg') }}
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-if="unitPrice20">
        <a-col :span="12">
          <a-form-item label="方案编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <j-dict-select-tag
              :triggerChange="true"
              dictCode="efs_scheme_unit_price,code,code,status='30' and del_flag = 'N'"
              v-decorator="['schemeUnitPriceCode', validatorRules.schemeUnitPriceCode]"
              @change="handleUnitPriceSchemeChange($event)"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="方案名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="schemeUnitPriceName" disabled></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="公式" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="schemeUnitPriceFormula" disabled></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="schemeUnitPriceDes" disabled></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </j-form-container>
</template>
<script>
    import pick from 'lodash.pick'
    import JFormContainer from '@/components/jeecg/JFormContainer'
    import { getAction } from '@/api/manage'

    export default {
        name: 'RecycleFeeForm',
        components: {
            JFormContainer,
        },
        props:{
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            // 当前table对应的数据表名
            tableName: {
              type: String,
              default: ''
            }

        },
        data () {
            return {
                form: this.$form.createForm(this),
                model: {},
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                labelCol2: {
                    xs: { span: 24 },
                    sm: { span: 3 },
                },
                wrapperCol2: {
                    xs: { span: 24 },
                    sm: { span: 20 },
                },
                validatorRules: {
                    roosterLevelOne: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPriceForTheRecoveryOfMaleBirdAGrade')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    roosterLevelTwo: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPriceOfMaleBirdBGrade')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    roosterLevelThree: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPriceOfMaleBirdResidualRecovery')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    henLevelOne: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPriceForTheRecoveryOfFemaleBirdAGrade')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    henLevelTwo: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPriceOfBGradeOfFemaleBirds')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    henLevelThree: {
                        rules: [
                            { required: true, message: this.$t('label.pleaseEnterTheUnitPriceOfFemalePoultryResidualRecovery')},
                            { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
                        ]
                    },
                    unitPriceType: {
                        rules: [
                            { required: true, message: '请选择单价类型!'},
                        ]
                    },
                    schemeUnitPriceCode: {
                        rules: [
                            { required: true, message: '请选择方案编号!'},
                        ]
                    },
                },
                confirmLoading: false,
                unitPrice10: true,
                unitPrice20: false,
                schemeUnitPriceFormula: null,
                schemeUnitPriceName: null,
                schemeUnitPriceDes: null,
                url: {
                    querySchemeByCode: "/efs/scheme/unitprice/queryByCode",
                },
            }
        },
        methods:{
            initFormData(url,id){
                this.clearFormData()
                if(!id){
                    this.edit({})
                }else{
                    getAction(url,{id:id}).then(res=>{
                        if(res.success){
                            let records = res.result
                            if(records && records.length>0){
                                this.edit(records[0])
                            }
                        }
                    })
                }
            },
            edit(record){
                this.model = Object.assign({}, record)
                if(this.model.unitPriceType){
                    this.handleUnitPriceChange(this.model.unitPriceType)
                    if(this.model.schemeUnitPriceCode){
                        this.handleUnitPriceSchemeChange(this.model.schemeUnitPriceCode)
                    }
                }else {
                    this.unitPrice10 = true;
                    this.unitPrice20 = false;
                    this.schemeUnitPriceFormula = null;
                    this.schemeUnitPriceName = null;
                    this.schemeUnitPriceDes = null;
                }
                console.log("RecycleFeeForm-edit",this.model);
                let fieldval = pick(this.model,'roosterLevelOne','roosterLevelTwo','roosterLevelThree','henLevelOne','henLevelTwo','henLevelThree','unitPriceType','schemeUnitPriceCode')
                this.$nextTick(() => {
                    this.form.setFieldsValue(fieldval)
                })

            },
            getFormData(){
                let formdata_arr = []
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let formdata = Object.assign(this.model, values)
                        let isNullObj = true
                        Object.keys(formdata).forEach(key=>{
                            if(formdata[key]){
                                isNullObj = false
                            }
                        })
                        if(!isNullObj){
                            formdata_arr.push(formdata)
                        }
                    }else{
                        this.$emit("validateError",this.$t('tip.contractBreakdownSheetFailedTo'));
                    }
                })
                console.log("合同明细表单数据集",formdata_arr);
                return formdata_arr;
            },
            clearFormData(){
                this.form.resetFields()
                this.model={}
            },
            handleUnitPriceChange(event){
                if(event == "10"){
                    this.unitPrice10 = true;
                    this.unitPrice20 = false;
                }else if(event == "20"){
                    this.unitPrice10 = false;
                    this.unitPrice20 = true;
                }else {
                    this.unitPrice10 = false;
                    this.unitPrice20 = false;
                }
            },
            handleUnitPriceSchemeChange(event){
                getAction(this.url.querySchemeByCode, { code: event }).then((res) => {
                    if (res.success) {
                      this.schemeUnitPriceFormula = res.result.formula;
                      this.schemeUnitPriceName = res.result.name;
                      this.schemeUnitPriceDes = res.result.description;
                    }else {
                        this.$emit("validateError", res.message);
                    }
                })
            }
        }
    }
</script>
